<template>
  <LoginLayout>
    <template v-if="!isComplete">
      <div class="title">找回密码</div>
      <div class="resg-progress layout flex-center">
        <div class="progress-item layout flex-center" @click="backQian" style="cursor: pointer"
            :class="isNext ? 'next' : 'action'" >
          <span class="icon">1</span>
          <span class="content">忘记密码</span>
        </div>
        <div class="cut" :class="isNext ? 'action' : ''"></div>
        <div
            class="progress-item layout flex-center"
            :class="isNext ? 'action' : ''"
        >
          <span class="icon">2</span>
          <span class="content">修改密码</span>
        </div>
      </div>
      <el-form :model="formObj" ref="form" v-show="!isNext" :rules="rules1">
        <el-form-item prop="phone">
          <el-input
              placeholder="请输入手机号"
              prefix-icon="el-icon-mobile-phone"
              class="input"
              v-model="formObj.phone"
              :maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="layout">
            <!-- <el-input
                 placeholder="请输入验证码"
                 v-model="formObj.code"
                 class="flex input"
                 :maxlength="6">
               <img slot="prefix" width="20px" src="@/assets/img/yanzhengma.png" alt="">
               <el-button slot="suffix">点击验证</el-button>
             </el-input>-->
            <el-button type="primary" class="btn" plain @click="yanzheng">点击验证</el-button>
            <div class="code flex-none"></div>
          </div>
        </el-form-item>
        <el-form-item class="last layout">
          <router-link class="link" to="/login"
          >我知道密码，使用密码登录
          </router-link
          >
        </el-form-item>
      </el-form>
      <vue-sim-captcha
          v-model="captcha.showCaptcha"
          :appId="captcha.appId"
          :callback="saveTicket"
          :source="captcha.source"
      ></vue-sim-captcha>
      <el-form v-show="isNext" ref="info" :model="formObj" :rules="rules2">
        <el-form-item prop="phone">
          <el-input
              placeholder="请输入手机号"
              prefix-icon="el-icon-mobile-phone"
              class="input"
              readonly
              v-model="formObj.phone"
              :maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item prop="phoneCode">
          <el-input
              placeholder="请输入手机验证码"
              prefix-icon="el-icon-message"
              class="input"
              :maxlength="6"
              v-model="formObj.phoneCode"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              class="input"
              :type="inputType"
              :maxlength="20"
              v-model="formObj.password"
          >
          <img style="width: 15px;margin-right: 5px;margin-top: 20px;" :src="flag?openeye:closeeye" slot="suffix"
                 @click="changePass"></el-input>
        </el-form-item>
        <el-form-item prop="newPassword">
          <el-input
              placeholder="请再次输入密码"
              prefix-icon="el-icon-lock"
              class="input"
              :type="inputTyper"
              :maxlength="20"
              v-model="newPassword"
          >
          <img style="width: 15px;margin-right: 5px;margin-top: 20px;" :src="flagr?openeye:closeeye" slot="suffix"
                 @click="changePassr"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="btn" @click="save">确定</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template v-else>
      <div class="layout flex-center regi-success">
        <img src="@/assets/img/ok.png" alt="ok"/>
        <p style="font-size: 14px; color: #595959">恭喜</p>
        <p>您已修改成功</p>
        <el-button class="goto" type="primary" @click="goto"
        >返回登录
        </el-button
        >
        <p>
          <span style="color: #1890ff">{{ time }}</span
          >秒后自动返回登录
        </p>
      </div>
    </template>
  </LoginLayout>
</template>

<script>
import LoginLayout from "@/components/login-layout";
import rigisterService from "@/apis/rigisterService";

export default {
  data() {
    let phoneValid = (rule, value, callback) => {
      if (!/^1[0-9]{10}/.test(value)) {
        return callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    let passwordValid = (rule, value, callback) => {
      if (this.newPassword.length < 6) {
        return callback(new Error("密码长度不少于6位"));
      }
      if (!this.newPassword) {
        return callback(new Error("请再次输入密码"));
      }
      if (this.formObj.password !== this.newPassword) {
        return callback(new Error("两次输入密码不一致"));
      }
      return callback();
    };
    return {
      flag:false,
      flagr:false,
      inputType:'password',
      inputTyper:'password',
      openeye:require('@/assets/img/open-eye.png'),
			closeeye:require('@/assets/img/close-eye.png'),
      formObj: {},
      isNext: false,
      isComplete: false,
      time: 3,
      timer: null,
      newPassword: "",
      rules1: {
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {validator: phoneValid, trigger: "blur"},
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      rules2: {
        phoneCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
        password: [{required: true, message: "请输入密码", trigger: "blur"},
          {min: 6, max: 20, message: "密码最少六位", trigger: "blur"}
        ],
        newPassword: [
          {
            validator: passwordValid,
            trigger: "blur",
          },
        ],
      },
      // 验证码相关信息
      captcha: {
        appId: "132132",
        source: {
          baseURL: this.$baseURL, // 改为你自己的
          imgUrl: "/Yunos/User/VCodeImg",
          checkUrl: "/Yunos/User/VCodeCheck",
          // baseURL: "https://captcha.moeci.com", // 请替换为你自己的验证服务端url
          // imgUrl: "/api/vCode/VCodeImg",
          // checkUrl: "/api/vCode/VCodeCheck"
        },
        showCaptcha: false, // 控制显示隐藏验证码层
        ticket: "", // 来自验证服务端
        userId: ""  // 来自验证服务端
      },
    };
  },
  methods: {
    changePass() {
				this.flag = !this.flag;
				this.flag && (this.inputType = 'type')
				!this.flag && (this.inputType = 'password')
      },
      changePassr() {
				this.flagr = !this.flagr;
				this.flagr && (this.inputTyper = 'type')
				!this.flagr && (this.inputTyper = 'password')
			},
    backQian(){
      this.formObj.phoneCode = "";
      this.formObj.password = "";
      this.newPassword = "";
      this.isNext = false;
    },
    // 验证服务端确认验证通过后,将回调此函数,无需关注内部实现,将由vue-sim-captcha.js自动完成与验证服务端captcha.moeci.com的交互
    saveTicket(res) {
      if (res.code === 0) {
        this.next();
      }
    },
    yanzheng() {
      this.$refs.form.validateField("phone", (valid) => {
        if (!valid) {
          this.captcha.showCaptcha = true;
        }
      })
    },
    next() {
      rigisterService.getCode({phone: this.formObj.phone,validRegType:2}).then((res) => {
        // this.formObj.phoneCode = res;
        this.isNext = true;
        // this.time = 60;
        // this.timemove();
      });
    },
    save() {
      this.$refs.info.validate((valid) => {
        if (valid) {
          rigisterService.yanCode({
            "phone": this.formObj.phone,
            "phoneCode": this.formObj.phoneCode,
            "validRegType":2
          }).then(res => {
            rigisterService.forget({
              phone: this.formObj.phone,
              phoneCode: this.formObj.phoneCode,
              password: this.formObj.password,
            }).then(r => {
              this.isComplete = true;
              this.time = 3;
              this.timemove();
            }, () => {

            })
          }, (e) => {

          })
        }
      });
    },
    timemove() {
      this.timer = setInterval(() => {
        if (this.time > 1) {
          this.time--;
        } else {
          clearInterval(this.timer);
          this.goto();
        }
      }, 1000);
    },
    goto() {
      this.$router.push("/login");
    },
  },
  components: {
    LoginLayout,
  },
};
</script>

<style lang="scss" scoped>
.resg-progress {
  margin-bottom: 35px;

  .cut {
    height: 1px;
    width: 48px;
    background: #bfbfbf;
    margin: 0 33px;

    &.action {
      background: #1890ff;
    }
  }

  .progress-item {
    color: #bfbfbf;

    .icon {
      display: flex;
      background-color: #f0f0f0;
      margin-right: 10px;
      width: 33px;
      height: 33px;
      border-radius: 50%;
      justify-content: center;
      align-items: center;
    }

    &.next {
      .icon {
        background-color: #ccecff;
        color: #ffffff;
      }
    }

    &.action {
      color: #333333;

      .icon {
        background-color: #1b9aee;
        color: #ffffff;
      }
    }
  }
}

.regi-success {
  font-size: 12px;
  flex-direction: column;
  color: #8c8c8c;

  p {
    line-height: 2;
  }

  .goto {
    margin-top: 20px;
    margin-bottom: 10px;
    width: 200px;
  }
}

.input {
  line-height: 50px;

  ::v-deep  input {
    line-height: 50px;
    height: 50px;
    padding-left: 40px;
  }

  ::v-deep  .el-input__prefix {
    font-size: 20px;
  }
}

.btn {
  width: 100%;
  height: 50px;
  font-size: 20px;
}

.link {
  color: #1890ff;
  text-decoration: none;
}

.last {
  justify-content: flex-end;
}
</style>
